import { useSelector } from 'react-redux';
import { getDeletedViewIds } from '../selectors/viewsSelectors';
import { useSelectedObjectTypeId } from '../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
const emptyValue = new Set();
export const useDeletedViewIds = () => {
  const objectTypeId = useSelectedObjectTypeId();
  const deletedViewIds = useSelector(getDeletedViewIds);
  return new Set(deletedViewIds[objectTypeId]) || emptyValue;
};